import CrudService from "@utils/CrudService";

export default new (class UserService extends CrudService {
})({
    domainName:'admin',
    entityName:'user',
    fields: ['email', 'password', 'roles'],
    query:['role_slug'],
});